import { AxiosApi } from './axiosApi'

import { configureAuthenticatedAPI } from '../configuration/authenticated'

class AuthenticatedAPI extends AxiosApi {
  constructor({
    domain,
    apiKey,
    useInterceptors = true
  }: {
    domain: string
    apiKey?: string
    useInterceptors?: boolean
  }) {
    super(configureAuthenticatedAPI(domain, apiKey, useInterceptors))
  }
}

export { AuthenticatedAPI }
